import {useQuery} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import type {AgentQuotaSnapshot} from '@github-ui/agent-sessions-types/agent-quota-snapshot'

type AgentQuotaSnapshotResponse = {
  agentQuotaSnapshot?: AgentQuotaSnapshot
}

export const AGENT_QUOTA_SNAPSHOT_QUERY_KEY = ['copilot-assignment', 'agent-quota-snapshot'] as const

// Quota state is user/session-scoped and time-sensitive, so it is intentionally
// not persisted — stale quota can block or enable assignment incorrectly.
export function agentQuotaSnapshotQueryOptions() {
  return {
    queryKey: AGENT_QUOTA_SNAPSHOT_QUERY_KEY,
    queryFn: async (): Promise<AgentQuotaSnapshot | null> => {
      try {
        const response = await reactFetch('/copilot/agent-sessions/quota-snapshot', {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })

        if (!response.ok) {
          return null
        }

        const data = (await response.json()) as AgentQuotaSnapshotResponse
        return data.agentQuotaSnapshot ?? null
      } catch {
        return null
      }
    },
    staleTime: 30 * 1000, // 30 seconds — balance fresh quota percentages with UI stability
  }
}

export function useAgentQuotaSnapshot({enabled = true}: {enabled?: boolean} = {}) {
  return useQuery<AgentQuotaSnapshot | null>({
    ...agentQuotaSnapshotQueryOptions(),
    enabled,
  })
}
